import React from 'react';
import PropTypes from 'prop-types';
import fox from 'assets/wip.png';
import { useTheme } from '@mui/material/styles';
import { Dialog, DialogContent } from '@mui/material';
import { TransitionGroup } from 'react-transition-group';
import FadeTransition from 'components/transitions/Fade';
import CloseIcon from '@mui/icons-material/Close';

const WhatInPack = ({ item, open, onClose }) => {
  const theme = useTheme();
  return (
    <TransitionGroup>
      <FadeTransition>
        <Dialog
          onRequestClose={onClose}
          open={open}
        >
          <DialogContent sx={{ backgroundColor: theme.palette.common.white }}>
            <CloseIcon style={{ width: '15px', height: '15px', color: '#0076BB', cursor: 'pointer', position: 'absolute', top: '10px', left: '10px' }} onClick={onClose} />
          </DialogContent>
          {item && item.length > 0 && (
            <DialogContent sx={{ backgroundColor: theme.palette.common.white, color: theme.palette.common.black }}>
              <img src={fox} alt='item' />
              <div style={{ fontSize: '16px', fontWeight: '700', lineHeight: '22px', color: '#0076BB', fontFamily: 'NewOrderBold', textAlign: 'center' }}>Your pack includes...</div>
              &nbsp;
              &nbsp;
              <div style={{ fontSize: '16px', fontWeight: '400', lineHeight: '24px', fontFamily: 'NiveauGroteskRegular' }}>If selected and confirmed as a host, your exclusive Party Pack will contain everything you need to throw the Ultimate Soccer Watch Party.</div>
              &nbsp;
              <div style={{ fontSize: '16px', fontWeight: '400', lineHeight: '24px', fontFamily: 'NiveauGroteskRegular', marginBottom: '1%' }}>If you have any questions about your Party Pack items please reach out to us at <a href='/support' style={{ textDecoration: 'underline' }}>{process.env.APP_URL}/support</a></div>
            </DialogContent>
          )}
        </Dialog>
      </FadeTransition>
    </TransitionGroup>
  );
};
WhatInPack.propTypes = {
  item: PropTypes.array.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default WhatInPack;
